import { CombinedRecord, getTo } from "./HistoryTab";
import convertStatus from '../utils/convertStatus';

interface RecordProps {
  title: string;
  isLoading: boolean;
  selectedRecord: CombinedRecord | null;
  setSelectedRecord: (record: CombinedRecord) => void;
  records: CombinedRecord[];
}

export default function EmailSection({ title, isLoading, selectedRecord, setSelectedRecord, records }: RecordProps) {
  return (
    <>
      <h4>
        {title}
      </h4>
      {records.length !== 0 ? (
        isLoading ? (
          <p>Loading...</p>
        ) : (
          records
            .slice()
            .map((record) => {
              return (
                <li
                  className={`record`}
                  style={{
                    backgroundColor: convertStatusToColor(record.status),
                    opacity: record.status === 'Pending' ? 0.5 : 1,
                    border: selectedRecord?.id === record.id ? "1px solid rgba(0,0,0,.5)" : "none"
                  }}
                  key={record.id}
                  onClick={() => setSelectedRecord(record)}
                >
                  <p className='bold'>
                    {record.isReview ? 'Granskning' : 'E-mail'}
                  </p>
                  <p>
                    {convertStatus(record.status)}
                  </p>
                  {(!record.isReview || record.status === 'CHANGE_REQUESTED' || record.status === 'APPROVED') &&
                    <p>{record.isReview ? "Från" : "Till"}: {getTo(record)}</p>
                  }
                  <p>{record.date.toLocaleString()}</p>
                </li>
              );
            })
        )
      ) : (
        <li>Inga mail hittades</li>
      )}
    </>
  )
}

function convertStatusToColor(statusString: string) {
  const statusColors: Record<string, string> = {
    Sent: 'rgba(0, 255, 0, 0.150)',
    Pending: 'rgba(255, 119, 0, 0.200)',
    Held: 'rgba(255, 0, 0, 0.150)',
    HardFail: 'rgba(255, 0, 0, 0.150)',
  };

  return statusColors[statusString] || 'rgba(255, 0, 0, 0.150)';
}
